<template>
  <div class="grid">
    <v-progress-linear color="warning" indeterminate rounded height="3"
      v-if="isLoading || disableSaveBtn"></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem && !isLoading">
      <div class="grid-title">
        <h4>
          {{
            $t(
              isAddNew
                ? "_ACTIVITY.HOTEL_ROOM_PLAN_CREATE"
                : "_ACTIVITY.HOTEL_ROOM_PLAN_UPDATE"
            )
          }}
        </h4>
      </div>
      <div class="grid-body p-3 border-top-unset mb-4">
        <v-row>
          <v-col sm="12">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-row>
                  <v-col sm="12">
                    <label>{{ $t("SELLING_PACKAGE") }} *</label>
                    <v-text-field v-model="editedItem.nameVi" counter maxlength="250" class="input-counter"
                      :rules="ruleName" outlined dense v-on:keyup="updateRoomTitle(editedItem.nameVi)">
                    </v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <label class="mb-1">{{ $t("SERVICE.BENEFIT") }}</label>
                    <tinycme-editor v-model="editedItem.benefitVi" :lang="sysLang" @input="updateRoomBenefit(editedItem.benefitVi)"></tinycme-editor>
                  </v-col>
                  <v-col sm="12">
                    <label>{{ $t("SERVICE.DESCRIPTION_INFO_DEFAULT") }}</label>
                    <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                      class="input-counter" v-model="editedItem.descriptionVi" dense outlined
                      v-on:keyup="updateRoomDescription(editedItem.descriptionVi)">
                    </v-textarea>
                  </v-col>
                  
                </v-row>
              </v-tab-item>
              <v-tab-item v-for="code in codeLangs" :key="code">
                <v-row>
                  <v-col sm="12">
                    <label>{{ $t("NAME_SELLING_PACKAGE") }} *</label>
                    <v-text-field v-model="editedItem.i18ns.find((x) => x.lang == code).name" counter maxlength="250"
                      class="input-counter" :rules="ruleName" outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col sm="12">
                    <label class="mb-1">{{ $t("SERVICE.BENEFIT") }}</label>
                    <tinycme-editor v-model="editedItem.i18ns.find((x) => x.lang == code).benefit" :lang="sysLang"></tinycme-editor>
                  </v-col>
                  <v-col sm="12">
                    <label>{{ $t("DESCRIPTION_INFO") }}</label>
                    <v-textarea :rows="3" :rules="ruleDescNotRequired" counter="3000" maxlength="3000"
                      class="input-counter" v-model="editedItem.i18ns.find((x) => x.lang == code).description" dense
                      outlined>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>

        <v-divider />
        <div>
          <label class="label-title">{{ $t("SELLING_PACKAGE_INFO") }}</label><br />
          <p class="mb-0 mt-2" v-if="editedItem.chainCode">
            {{ $t("CHAIN_CODE") }}: {{ editedItem.chainCode }}
          </p>
          <v-row>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.SALE_PACKAGE_CODE") }} *</label>
              <v-text-field v-model="editedItem.ratePlanCode"
                v-on:keyup="validateSalePackageCode(editedItem.ratePlanCode)" :disabled="isDisableSalePackageCode"
                :rules="ruleCode" :error="isDuplicateSalePackageCode" outlined counter maxlength="20"
                class="input-counter code" dense>
              </v-text-field>
              <small v-if="isDuplicateSalePackageCode" class="invalid-text">{{
                $t("_SERVICE_PACKAGE.ERROR_SALE_PACKAGE_CODE")
              }}</small>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("MEALS_INCLUDE") }}</label>

              <v-select item-text="text" item-value="value" :items="select.meals" v-model="editedItem.lstMealId" multiple
                outlined dense>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleMeal">
                    <v-list-item-action>
                      <v-icon :color="editedItem.lstMealId.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconMeal }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t("ALL") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-0 mb-0"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.AGE_MAX_CHILD") }}</label>
              <v-select :items="select.child" v-model="editedItem.ageMaxChild" outlined dense>
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SERVICE_PACKAGE.AGE_MAX_BABY") }}</label>
              <v-select :items="select.child" v-model="editedItem.ageMaxBaby" dense outlined>
              </v-select>
            </v-col>
            <v-col sm="3" class="pb-0">
              <v-checkbox color="indigo darken-3" :label="$t('ACTIVATE')"
                v-model="editedItem.status" />
            </v-col>
            <v-col sm="3" class="pb-0">
              <v-checkbox color="indigo darken-3" :label="$t('INCLUDED_TAX')"
                :value="editedItem.includedTax" v-model="editedItem.includedTax"></v-checkbox>
            </v-col>
            <v-col sm="3" class="pb-0">
              <label>{{ $t("_SALE_PACKAGE.RATE_CATEGORY") }}</label>
              <v-select :items="rateCategoryList" item-text="name" item-value="id" v-model="editedItem.rateCategoryId"
                outlined dense clearable>
              </v-select>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <div>
          <label class="label-title">{{ $t("_ACTIVITY.APPLY_DATE") }}</label><br />
          <v-row>
            <v-col sm="6" class="pb-0">
              <v-row class="align-center">
                <v-col sm="3">
                  <label>{{ $t("TIME_STAY") }}</label>
                </v-col>
                <v-col sm="9">
                  <v-radio-group row v-model="editedItem.session" class="pl-2 pt-0 mt-0" @change="isConfirmSave = true">
                    <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
                    <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="align-center mt-0">
                <v-col sm="6" class="pb-0 pt-0">
                  <date-picker :model.sync="editedItem.startDate" :disabled="!editedItem.session" :min="currentDate()"
                    class="outlined" @changeData="isConfirmSave = true" :error.sync="error.startDate.error"
                    :placeholder="$t('FROM_DATE')" />
                </v-col>
                <v-col sm="6" class="pb-0 pt-0">
                  <date-picker :model.sync="editedItem.endDate" :disabled="!editedItem.session"
                    :min="editedItem.startDate" @changeData="isConfirmSave = true" :error.sync="error.endDate.error"
                    :placeholder="$t('TO_DATE')" />
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="6" class="pb-0">
              <v-row class="align-center">
                <v-col>
                  <label>{{ $t("_SERVICE_PACKAGE.DAY_APPLY_IN_WEEK") }}</label>
                </v-col>
              </v-row>
              <v-row class="align-center mt-0">
                <v-col class="pb-0 pt-0">
                  <v-layout wrap>
                    <v-chip-group v-model="weekend" column multiple @change="isConfirmSave = true" active-class="primary">
                      <v-chip v-for="date in daysOfWeek" :value="date.date" class="chip-date">
                        {{ date.text }}
                      </v-chip>
                    </v-chip-group>
                  </v-layout>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col sm="12" class="pb-0">
            <label>{{ $t("NOT_APPLY_RANGE_DATE") }}</label>
            <v-row>
              <v-col sm="6" class="pt-0" v-for="(range, i) in editedItem.rateBlackouts" :key="i">
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <date-picker :model.sync="range.startDate" :min="currentDate()" class="outlined"
                      @changeData="isConfirmSave = true" :placeholder="$t('FROM_DATE')" />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <date-picker :model.sync="range.endDate" :min="range.startDate" @changeData="isConfirmSave = true"
                      :placeholder="$t('TO_DATE')" />
                  </v-col>
                  <v-col sm="1">
                    <v-icon color="error" @click="
                      removeRangeApplyDate(i);
                    isConfirmSave = true;
                    ">delete</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div>
              <v-btn small class="btn-expand mt-1" outlined depressed @click="
                addnotApplyDates();
              isConfirmSave = true;
              ">
                <v-icon> add </v-icon>
                {{ $t("ADD_RANGE_DAYS_NOT_APPLY") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">
            {{ $t("BACK") }}
          </v-btn>
          <v-btn color="primary" class="pr-10 pl-10" @click="editedItem.id ? confirmSave() : save(false)"
            :disabled="disableSaveBtn">{{ $t("SAVE") }}</v-btn>
        </div>
      </div>
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>{{  $t('ASSIGN_ROOM_TYPE') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col sm="3">
                <v-card>
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{ $t("UNASSIGN") }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('_BOOKING.SEARCH')" v-model="searchUnApply"
                      @input="searchOnUnApply" outlined dense></v-text-field>
                  </div>
                  <div style="height: 350px; overflow-y: auto" class="p-2">
                    <v-treeview
                    v-model="selectUnmap"
                    :search="searchUnApply"
                    :filter="filter"
                      selectable
                      selected-color="primary"
                      :items="roomMap"
                      open-on-click
                      selection-type="leaf"
                    ></v-treeview>
                  </div>
                </v-card>
              </v-col>
              <v-col sm="1" class="d-flex align-center justify-content-center">
                <div>
                  <v-btn class="d-block" @click="leftToRight">
                    <v-icon>navigate_next</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="rightToLeft">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="allLeftToRight">
                    <v-icon>keyboard_double_arrow_right</v-icon>
                  </v-btn>
                  <!-- <v-btn class="d-block mt-3" @click="allRightToLeft">
                    <v-icon>keyboard_double_arrow_left</v-icon>
                  </v-btn>
                  <v-btn class="d-block mt-3" @click="compare">
                    <v-icon>compare_arrows</v-icon>
                  </v-btn> -->
                </div>
              </v-col>
              <v-col sm="3">
                <v-card>
                  <v-card-title class="fs-12 text-uppercase font-weight-bold">{{ $t("ASSIGN") }}</v-card-title>
                  <div class="pl-2 pr-2">
                    <v-text-field prepend-inner-icon="mdi-magnify" :placeholder="$t('_BOOKING.SEARCH')" v-model="searchApply" outlined dense></v-text-field>
                  </div>
                  <div style="height: 350px; overflow-y: auto" class="p-2">
                    <v-treeview
                    v-model="selectMap"
                    :search="searchApply"
                    :filter="filter"
                    selectable
                    selected-color="primary"
                    :items="roomsMaped"
                    open-on-click
                    selection-type="leaf"
                    item-disabled="locked"
                    ></v-treeview>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">
                {{ $t("BACK") }}
              </v-btn>
              <v-btn color="primary" class="pr-10 pl-10" @click="editedItem.id ? confirmSave() : save(false)"
                :disabled="disableSaveBtn">{{ $t("SAVE") }}</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{  $t('PROMOTION_CHARCE_COUPON') }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col>
                <label class="label-title mb-3">{{  $t('PROMOTION_CHARGE') }}</label>
                <draggable class="list-group-theme" v-model.lazy="listPromotionType_0" handle=".handle" animation="150" @input="changeIndex()">
                    <div class="item-cancel-policy mb-2" v-for="pro in listPromotionType_0" :key="pro">
                      <div class="d-flex mb-3">
                        <div class="mr-auto"  :class="promotions.find(p => p.id === pro).active === 0 ? 'text-secondary' : 'text-primary'">
                          <p class="fs-14 mb-0 ">{{promotions.find(p => p.id === pro).promotionCode}}</p>
                          <p>{{promotions.find(p => p.id === pro).promotionName}}</p>
                        </div>

                        <div class="text-right">
                          <v-btn depressed x-small  class="rounded-sm sort mr-1 handle" outlined
                            style="cursor: move">
                            <i class="icon-swap_vert fs-16">
                            </i>
                          </v-btn>
                          <v-btn depressed color="error" @click="removePromotion(pro)" x-small  class="rounded-sm" outlined>
                            <i class="icon-delete fs-16"></i>
                          </v-btn>
                        </div>
                      </div>
                      <span>{{pro.description}}</span>
                    </div>
                </draggable>
                <div>
                  <v-btn small class="btn-expand mt-1" outlined depressed @click="
                    addPromotion(0)">
                    <v-icon> add </v-icon>
                    {{ $t("ADD_PROGRAM") }}
                  </v-btn>
                </div>
              </v-col>
              <v-col>
                <label class="label-title mb-3">{{  $t('COUPON_APPLY') }}</label>
                <!-- <draggable class="list-group-theme" v-model="editedItem.promotions" handle=".handle" animation="150"> -->
                  <div class="item-cancel-policy mb-2" v-for="(pro, index) in editedItem.promotions.filter(e => promotions.find(p => p.id === e && p.promotionType === 1))" :key="index">
                    <div class="d-flex mb-3">
                      <div class="mr-auto" :class="promotions.find(p => p.id === pro).active === 0 ? 'text-secondary' : 'text-primary'">
                        <p class="fs-14 mb-0 ">{{promotions.find(p => p.id === pro).promotionCode}}</p>
                        <p>{{promotions.find(p => p.id === pro).promotionName}}</p>
                      </div>

                      <div class="text-right">
                        <!-- <v-btn depressed x-small  class="rounded-sm sort mr-1 handle" outlined
                          style="cursor: move">
                          <i class="icon-swap_vert fs-16">
                          </i>
                        </v-btn> -->
                        <v-btn depressed color="error" @click="removePromotion(pro)" x-small  class="rounded-sm" outlined>
                          <i class="icon-delete fs-16"></i>
                        </v-btn>
                      </div>
                    </div>
                    <span>{{pro.description}}</span>
                  </div>
                <!-- </draggable> -->
                <div>
                  <v-btn small class="btn-expand mt-1" outlined depressed @click="
                    addPromotion(1)">
                    <v-icon> add </v-icon>
                    {{ $t("ADD_PROGRAM") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">
                {{ $t("BACK") }}
              </v-btn>
              <v-btn color="primary" class="pr-10 pl-10" @click="editedItem.id ? confirmSave() : save(false)"
                :disabled="disableSaveBtn">{{ $t("SAVE") }}</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t("POLICY") }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <v-row>
                <v-col sm="6" class="pt-0">
                  <label>{{ $t("_SERVICE_PACKAGE.APPLY_OBJECT") }}</label>
                  <v-select :items="select.applyFor" v-model="editedItem.rateParties" outlined chips multiple>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggleObject">
                        <v-list-item-action>
                          <v-icon :color="editedItem.rateParties.length > 0 ? 'indigo darken-4' : ''
                            ">
                            {{ iconObject }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("ALL") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-0 mb-0"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0 || index === 1 || index === 2">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text caption">(+{{ editedItem.rateParties.length - 3
                      }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-select>
                </v-col>
                <v-col sm="6" class="pt-0">
                  <label>{{ $t("_SERVICE_PACKAGE.APPLY_CARD") }}</label>
                  <v-select item-text="text" item-value="value" :items="select.cardApply" v-model="editedItem.rateCards"
                    outlined chips multiple>
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggleCard">
                        <v-list-item-action>
                          <v-icon :color="editedItem.rateCards.length > 0 ? 'indigo darken-4' : ''
                            ">
                            {{ iconCard }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("ALL") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-0 mb-0"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0 || index === 1 || index === 2">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text caption">(+{{ editedItem.rateCards.length - 3 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col sm="6" class="pb-0">
                  <label class="label-title">
                    {{ $t("_SERVICE_PACKAGE.PAYMENT_POLICY") }}
                  </label>
                  <br />
                  <div class="current-cancellation" v-for="(itemPay, index) in editedItem.ratePayments">
                    <v-row align="center">
                      <v-col sm="11">
                        <h6>{{ itemPay.nameVi }}</h6>
                        <p v-if="itemPay.depositI18n.length > 0">
                          {{
                            itemPay.depositI18n.find((e) => e.lang === defaultI18n)
                              .description
                          }}
                        </p>
                      </v-col>
                      <v-col sm="1">
                        <v-icon color="error" @click="removeOldratePayments(index)">
                          delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="current-cancellation" v-for="(detail, index) in ratePaymentsAddIds">
                    <v-row align="center">
                      <v-col sm="11">
                        <h6>{{ detail.nameVi }}</h6>
                        <p v-if="detail.depositI18n.length > 0">
                          {{
                            detail.depositI18n.find((e) => e.lang === defaultI18n).description
                          }}
                        </p>
                      </v-col>
                      <v-col sm="1">
                        <v-icon color="error" @click="removeNewratePayments(index)">
                          delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>

                  <v-dialog v-model="dialogPaymentPolicy" width="700">
                    <template v-slot:activator="{ on, paymentPolicy }">
                      <v-btn small class="btn-expand mt-1" outlined depressed v-bind="paymentPolicy" v-on="on">
                        <v-icon> add </v-icon>
                        {{ $t("_SERVICE_PACKAGE.ADD_PAYMENT_POLICY") }}
                      </v-btn>
                    </template>
                    <v-toolbar class="toolbar-update" dense>
                      <v-toolbar-title class="text-primary fs-15">
                        <strong>{{ $t("_SERVICE_PACKAGE.PAYMENT_POLICY") }}</strong>
                      </v-toolbar-title>
                    </v-toolbar>
                    <div class="content-update">
                      <v-row>
                        <v-col sm="6" v-for="item in select.paymentPolicy">
                          <div class="item-cancel-policy">
                            <v-row align="center">
                              <v-col sm="7" class="pt-0 pb-0">
                                <h6>{{ item.nameVi }}</h6>
                              </v-col>

                              <v-col sm="5">
                                <v-btn v-if="!isPaymentSelected(item.id)" color="primary"
                                  @click="addRatePaymentsAddIds(item)">
                                  {{ $t("APPLY") }}
                                </v-btn>
                                <v-btn v-else class="bg-danger text-white" @click="
                                  updateRatePaymentsAddIds(item)
                                  ">
                                  {{ $t("UPDATE") }}
                                </v-btn>
                              </v-col>
                            </v-row>
                            <span v-if="item.depositI18n && item.depositI18n.length > 0">{{
                              item.depositI18n.find((e) => e.lang === defaultI18n).description
                            }}</span>
                          </div>
                        </v-col>
                      </v-row>
                      <div class="mt-4 text-right">
                        <v-btn class="" color="primary" @click="dialogPaymentPolicy = false">
                          {{ $t("CLOSE") }}
                        </v-btn>
                      </div>
                    </div>
                  </v-dialog>
                </v-col>
                <v-col sm="6" class="pb-0">
                  <label class="label-title">
                    {{ $t("_SERVICE_PACKAGE.CANCEL_POLICY") }}
                  </label>
                  <br />
                  <div class="current-cancellation" v-for="(itemRate, index) in editedItem.rateCancellations">
                    <v-row align="center">
                      <v-col sm="11">
                        <h6>{{ itemRate.nameVi }}</h6>
                        <p v-if="itemRate.cancellationI18n.length > 0">
                          {{
                            itemRate.cancellationI18n.find((e) => e.lang === defaultI18n)
                              .description
                          }}
                        </p>
                      </v-col>
                      <v-col sm="1">
                        <v-icon color="error" @click="removeOldCancellation(index)">
                          delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>

                  <div class="current-cancellation" v-for="(detail, index) in rateCancellationsAddIds">
                    <v-row align="center">
                      <v-col sm="11">
                        <h6>{{ detail.nameVi }}</h6>
                        <p v-if="detail.cancellationI18n.length > 0">
                          {{
                            detail.cancellationI18n.find((e) => e.lang === defaultI18n)
                              .description
                          }}
                        </p>
                      </v-col>
                      <v-col sm="1">
                        <v-icon color="error" @click="removeNewCancellation(index)">
                          delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>

                  <v-dialog v-model="dialogCancelPolicy" width="700">
                    <template v-slot:activator="{ on, cancelPolicy }">
                      <v-btn small class="btn-expand mt-1" outlined depressed v-bind="cancelPolicy" v-on="on">
                        <v-icon> add </v-icon>
                        {{ $t("_SERVICE_PACKAGE.ADD_CANCEL_POLICY") }}
                      </v-btn>
                    </template>
                    <v-toolbar class="toolbar-update" dense>
                      <v-toolbar-title class="text-primary fs-15">
                        <strong>{{ $t("_SERVICE_PACKAGE.CANCEL_POLICY") }}</strong>
                      </v-toolbar-title>
                    </v-toolbar>
                    <div class="content-update">
                      <v-row>
                        <v-col sm="6" v-for="item in select.cancelPolicy">
                          <div class="item-cancel-policy">
                            <v-row align="center">
                              <v-col sm="7" class="pt-0 pb-0">
                                <h6>{{ item.nameVi }}</h6>
                              </v-col>
                              <v-col sm="5">
                                <v-btn v-if="!isCancelSelected(item.id)" color="primary"
                                  @click="addRateCancellationsAddIds(item)">
                                  {{ $t("APPLY") }}
                                </v-btn>
                                <v-btn v-else color="red" dark @click="updateRateCancellationsAddIds(item)">
                                  {{ $t("UPDATE") }}
                                </v-btn>
                              </v-col>
                            </v-row>
                            <span v-if="item.cancellationI18n.length > 0">{{
                              item.cancellationI18n.find((e) => e.lang === defaultI18n)
                                .description
                            }}</span>
                          </div>
                        </v-col>
                      </v-row>
                      <div class="mt-4 text-right">
                        <v-btn class="" color="primary" @click="dialogCancelPolicy = false">
                          {{ $t("CLOSE") }}
                        </v-btn>
                      </div>
                    </div>
                  </v-dialog>
                </v-col>
              </v-row>
            </div>

            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">
                {{ $t("BACK") }}
              </v-btn>
              <v-btn color="primary" class="pr-10 pl-10" @click="editedItem.id ? confirmSave() : save(false)"
                :disabled="disableSaveBtn">{{ $t("SAVE") }}</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>{{ $t("MORE_OPTIONS") }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div class="d-flex">
                <div class="w-50 pr-3">
                  <div class="align-center d-flex mb-2">
                    <div class="mr-3">
                      <label class="label-title">{{ $t("TRAVEL_AGENT") }}</label>
                    </div>
                    <div>
                      <v-radio-group row v-model="travelAgentGeneral" class="pl-2 pt-0 mt-0" @change="editedItem.travelAgents = []">
                        <v-radio color="indigo darken-3" :label="$t('ALL')" value="ALL"></v-radio>
                        <v-radio color="indigo darken-3" :label="$t('TRAVEL_AGENT_SPEC')" value="SPEC"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                  <v-row class="align-center mt-0">
                    <v-col sm="12" class="pb-0 pt-0">
                    <v-autocomplete item-text="label" item-value="id" :items="listAgent" v-model="editedItem.travelAgents" outlined :disabled="travelAgentGeneral === 'ALL'" 
                      chips dense multiple>
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1"> <a class="text-primary"
                            @click=" editedItem.travelAgents = listAgent.map(e => e.id)">{{
                              $t('SELECT_ALL') }}</a>
                          | <a class="text-primary" @click=" editedItem.travelAgents = []">{{
                            $t('UN_SELECT_ALL') }}</a>
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs" :input-value="item.selected"
                          close @click:close=" removeChips(index, editedItem.travelAgents)" @click=" item.select">
                          <span>{{ item.label }}</span>
                        </v-chip>
                        <span v-if="index === 2" class="grey--text caption">(+{{
                          editedItem.travelAgents.length - 2 }})</span>
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
                <div class="w-50 pl-3">
                  <div class="align-center d-flex mb-2">
                    <div class="mr-3">
                      <label class="label-title">{{ $t("MARKET_SEGMENT") }}</label>
                    </div>
                    <div>
                      <v-radio-group row v-model="marketSegmentGeneral" class="pl-2 pt-0 mt-0" @change="editedItem.marketSegments = []">
                        <v-radio color="indigo darken-3" :label="$t('ALL')" value="ALL"></v-radio>
                        <v-radio color="indigo darken-3" :label="$t('SEGMENT_SPEC')" value="SPEC"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                  <v-row class="align-center mt-0">
                    <v-col sm="12" class="pb-0 pt-0">
                    <v-autocomplete item-text="label" item-value="id" :items="marketSegments" v-model="editedItem.marketSegments" outlined :disabled="marketSegmentGeneral === 'ALL'" 
                      chips dense multiple>
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1"> <a class="text-primary"
                            @click=" editedItem.marketSegments = marketSegments.map(e => e.id)">{{
                              $t('SELECT_ALL') }}</a>
                          | <a class="text-primary" @click=" editedItem.marketSegments = []">{{
                            $t('UN_SELECT_ALL') }}</a>
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs" :input-value="item.selected"
                          close @click:close=" removeChips(index, editedItem.marketSegments)" @click=" item.select">
                          <span>{{ item.label }}</span>
                        </v-chip>
                        <span v-if="index === 2" class="grey--text caption">(+{{
                          editedItem.marketSegments.length - 2 }})</span>
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <v-divider />
              <label class="label-title">{{ $t("_ROOM_SALE.SELL_MARKET") }}</label><br />
              <v-row>
                <v-col>
                  <v-radio-group v-model="applyAllMarket" class="mt-0">
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_ALL')" :value="'ALL'"
                      @change="applyAllMarketStatus()"></v-radio>
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_SPEC')" :value="'NOT_ALL'"
                      @change="applyAllMarketStatus()"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row v-if="listOfMarkets && applyAllMarket !== 'ALL'" class="room-list mb-5">
                <v-col md="3" class="child-no-margin py-0">
                  <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllMarket()"
                    v-model="selectAllMarket" />
                </v-col>

                <v-col md="3" class="child-no-margin py-0" v-for="market in listOfMarkets" :key="market.id">
                  <v-checkbox color="indigo darken-3" :label="market.value" :value="market.id"
                    v-model="editedItem.markets" @change="
                      editedItem.markets.length == listOfMarkets.length
                        ? (selectAllMarket = true)
                        : (selectAllMarket = false)
                      " />
                </v-col>
              </v-row>

              <v-divider />

              <label class="label-title">{{ $t("_ROOM_SALE.SELL_CHANNEL") }}</label><br />
              <v-row>
                <v-col>
                  <v-radio-group v-model="applyAllChannel" class="mt-0">
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_ALL')" :value="'ALL'"
                      @change="applyAllChannelStatus()"></v-radio>
                    <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_SPEC')" :value="'NOT_ALL'"
                      @change="applyAllChannelStatus()"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row v-if="listOfChannels && applyAllChannel !== 'ALL'" class="room-list mb-5">
                <v-col md="3" class="child-no-margin py-0">
                  <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllChannel"
                    v-model="selectAllChannel" />
                </v-col>
                <v-col md="3" class="child-no-margin py-0" v-for="channel in listOfChannels" :key="channel.id">
                  <v-checkbox color="indigo darken-3" :label="channel.value" :value="channel.id"
                    v-model="editedItem.channels" @change="
                      editedItem.channels.length == listOfChannels.length
                        ? (selectAllChannel = true)
                        : (selectAllChannel = false)
                      " />
                </v-col>
              </v-row>
            </div>

            <div class="btn-bottom">
              <v-btn depressed class="mr-5" @click="back">
                {{ $t("BACK") }}
              </v-btn>
              <v-btn color="primary" class="pr-10 pl-10" @click="editedItem.id ? confirmSave() : save(false)"
                :disabled="disableSaveBtn">{{ $t("SAVE") }}</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-dialog v-model="dialogConfirmSave" persistent max-width="390">
        <v-toolbar class="toolbar-update" dense>
          <v-toolbar-title class="text-primary fs-15">
            <strong>{{ $t("NOTIFICATION") }}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="content-update">
          <label class="s-label">{{ $t("DIALOG_CONFIRM_DESC") }}</label>
          <div class="mt-3 d-flex justify-content-between">
            <div class="w-100 mr-1">
              <v-btn depressed block @click="
                dialogConfirmSave = false;
              save(false);
              ">
                {{ $t("NO") }}
              </v-btn>
            </div>
            <div class="w-100 ml-1">
              <v-btn block color="primary" @click="
                dialogConfirmSave = false;
              save(true);
              ">
                {{ $t("YES") }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-dialog>
      <v-dialog v-model="dialogPromotion" max-width="790" scrollable>
        
        <v-card class="p-0">
          <v-toolbar class="toolbar-update" dense flat>
            <v-toolbar-title class="text-primary fs-15 mr-auto">
              <strong>{{ $t(typeAddPromotion === 0 ? "PROMOTION_CHARGE" : "COUPON_APPLY") }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-toolbar dense flat class="mb-3">
            <v-text-field
              outlined dense
              append-icon="mdi-magnify"
              v-model="txtSearchPromotion"
              :placeholder="$t('_BOOKING.SEARCH')"
              style="max-width: 250px"
            ></v-text-field>
          </v-toolbar>
          <v-card-text style="height: 600px;" class="px-3">
            <ul class="promotion-ul pl-0">
                <li v-for="(pro, c) in promotionListAdd.filter(e => e.promotionType === typeAddPromotion && !editedItem.promotions.includes(e.id) 
                && (e.promotionName.toString().toUpperCase().includes(txtSearchPromotion.toString().toUpperCase()) || e.promotionCode.toString().toUpperCase().includes(txtSearchPromotion.toString().toUpperCase())))" :key="c"  class="promotion-li">
                  <div class="item-cancel-policy">
                    <div class="d-flex mb-3">
                      <div class="mr-auto" :class="pro.active === 0 ? 'text-secondary' : 'text-primary'">
                        <p class="fs-14 mb-0">{{pro.promotionCode}}</p>
                        <p>{{pro.promotionName}}</p>
                      </div>

                      <div class="text-right">
                        <v-btn  color="primary" small :disabled="pro.active === 0"
                          @click="addPromotionToList(pro)">
                          {{ $t("APPLY") }}
                        </v-btn>
                      </div>
                    </div>
                    <span>{{pro.description}}</span>
                  </div>
                </li>
            </ul>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="text-right w-100">
              <v-btn class="" color="primary" @click="dialogPromotion = false">
                {{ $t("CLOSE") }}
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        
      </v-dialog>
    </v-form>
  </div>
</template>

<style lang="scss" scoped>
.promotion-ul {
    column-count: 2;
    column-gap: 30px;
    clear: both;
}
.promotion-li {
    padding-left: 0;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
}
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.code input {
  text-transform: uppercase;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}

.item-cancel-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.item-payment-policy {
  border: 1px dashed #cdcdcd;
  padding: 10px;

  p {
    margin-bottom: 0;
  }
}

.current-cancellation {
  background: linear-gradient(0deg, rgba(0, 62, 148, 0.1), rgba(0, 62, 148, 0.1)), #ffffff;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 5px;

  p {
    margin-bottom: 0;
  }
}
</style>
<script>
import store from "@/plugins/store";
import DatePicker from "@/components/Utils/DatePicker.vue";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";

import { _alert, _formatCurrency } from "@/_helpers/function.js";
import { DAYS_OF_WEEK, SPD_ERROR } from "@/_helpers/config.js";
import { categoryService } from "@/_services/SaleRoom/category.service.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { systemService } from "@/_services/system-data.service.js";
import { agentService } from "@/_services/HotelSetting/agent.service.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import draggable from 'vuedraggable';
import TinycmeEditor from '@/components/Utils/tinymce.vue'

export default {
  components: {
    "date-picker": DatePicker,
    Treeselect,
    draggable,
    TinycmeEditor
  },
  created() {
    this.currency = this.usedCurrency;
    this.getPromotion();
  },
  data() {
    return {
      panel: [0, 1],
      disableSaveBtn: false,
      isLoading: false,
      editedItem: null,
      tab: null,
      sysLang: this.$i18n.locale,
      lang: "vi",
      select: {
        child: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        baby: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        meals: [],
        paymentPolicy: [],
        cancelPolicy: [],
        applyFor: [],
        cardApply: [],
      },
      errors: SPD_ERROR,
      error: {
        startDate: {
          error: null,
          message: this.$t("_REGISTER.REQUIRED_FIELD"),
          required: null,
        },
        endDate: {
          error: null,
          message: this.$t("_REGISTER.REQUIRED_FIELD"),
          required: null,
        },
      },
      listMeal: [],
      isEmptyDefaultTitle: false,
      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      notApplyDates: [],
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      daysOfWeek: DAYS_OF_WEEK,
      weekend: [],
      defaultWeekend: [],
      ruleNotEmpty: [(v) => !!v || this.$t("NOT_EMPTY")],
      rateCancellationsAddIds: [],
      ratePaymentsAddIds: [],
      dialogCancelPolicy: false,
      dialogPaymentPolicy: false,
      isDuplicateSalePackageCode: false,
      isDisableSalePackageCode: false,
      isConfirmSave: false,
      dialogConfirmSave: false,
      clone: {
        editedItem: {
          ratePayments: [],
        },
      },
      isAddNew: true,
      rateCategoryList: [],
      marketSegments: [],
      listAgent: [],
      travelAgentGeneral: "ALL",
      marketSegmentGeneral: "ALL",
      rooms: [],
      roomRateRoot: [],
      otas: [],
      searchUnApply: null,
      searchApply: null,
      selectUnmap: [],
      selectMap: [],
      roomsMaped: [],
      roomMap: [],
      promotions: [],
      dialogPromotion: false,
      typeAddPromotion: 0,
      promotionListAdd: [],
      txtSearchPromotion: '',
      listPromotionType_0: [],
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : []
    };
  },
  computed: {
    likesAllRateParties() {
      return this.editedItem.rateParties.length === this.select.applyFor.length;
    },
    likesSomeRateParties() {
      return this.editedItem.rateParties.length > 0 && !this.select.applyFor;
    },
    iconObject() {
      if (this.likesAllRateParties) return "mdi-close-box";
      if (this.likesSomeRateParties) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllCard() {
      return this.editedItem.rateCards.length === this.select.cardApply.length;
    },
    likesSomeCard() {
      return this.editedItem.rateCards.length > 0 && !this.select.cardApply;
    },
    iconCard() {
      if (this.likesAllCard) return "mdi-close-box";
      if (this.likesSomeCard) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllMeal() {
      // this.select.meals.forEach(x => {
      //   this.editedItem.lstMealId.push(x.value);
      // });

      return this.editedItem.lstMealId.length === this.select.meals.length;

      // return this.editedItem.lstMealId;
    },
    likesSomeMeal() {
      return this.editedItem.lstMealId.length > 0 && !this.select.meals;
    },
    iconMeal() {
      if (this.likesAllMeal) return "mdi-close-box";
      if (this.likesSomeMeal) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    listOfRooms(value) {
      let element = document.querySelector(".btn-save");
      if (value.length > 0) {
        element.disabled = false;
      } else {
        element.disabled = true;
      }
    },
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.i18ns.find((x) => x.lang == value).description;
    },
    roomTyleApplied(value) {
      this.editedItem.rooms = [...value];
    },
    editedItem: {
      handler(value) {
        if(value.promotions) {
          this.listPromotionType_0 = value.promotions.filter(pro => this.promotions.find(e => e.id === pro && e.promotionType === 0));
        }
      },
      deep: true,
    },
    weekend(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0];
      value.forEach(function (element) {
        if (element === "MON") {
          tmp[0] = 1;
        }

        if (element === "TUE") {
          tmp[1] = 1;
        }

        if (element === "WED") {
          tmp[2] = 1;
        }

        if (element === "THU") {
          tmp[3] = 1;
        }

        if (element === "FRI") {
          tmp[4] = 1;
        }

        if (element === "SAT") {
          tmp[5] = 1;
        }

        if (element === "SUN") {
          tmp[6] = 1;
        }
      });

      this.editedItem.bitWeekDays = parseInt(tmp.join(""), 2);
    },
  },
  mounted() {},
  methods: {
    async getPromotion() {
      Promise.all([
        this.salePackageService(),
        this.getAllRateCategory(),
        this.getAllTravelAgent(),
        this.getAllSegment(),
        this.getAllRooms(),
        this.getOtas()
      ]).then(([
        getPromotion,
        rateCategoryList,
        listAgent,
        marketSegments,
        rooms,
        otas
      ]) => {
        if (getPromotion) {
          this.promotions = getPromotion;
          this.promotionListAdd = getPromotion;
        }

        if (rateCategoryList) {
          this.rateCategoryList = rateCategoryList.map((x) => {
            const i18n = x.i18ns.find(i18n => i18n.lang === this.defaultI18n);  
              return {
                  id: x.id,
                  name: i18n ? i18n.name : x.nameVi
              };
          });
        }

        if (listAgent) {
          this.listAgent = listAgent.map(e => Object.assign({}, {
            id: e.id,
            label: !e.active ? e.title + ` (${this.$t('DEACTIVE')})` : e.title,
            disabled: !e.active,
          }));
        }

        if (marketSegments) {
          this.marketSegments = marketSegments.map(e => Object.assign({}, {
            id: e.id,
            label: e.active != 1 ? e.name + ` (${this.$t('DEACTIVE')})` : e.name,
            disabled: e.active != 1,
          }));
        }

        if (rooms) {
          this.rooms = rooms.map(x => {
            return {
              id: x.roomId,
              name: x.i18ns.find(y => y.lang == this.defaultI18n).name
            };
          });
          this.roomMap = rooms.map(x => {
            return {
              id: x.roomId,
              name: x.i18ns.find(y => y.lang == this.defaultI18n).name,
              children: []
            };
          });
        }

        if (otas) {
          this.otas = otas.map(x => {
            return {
              id: x.id,
              name: x.otaI18n.find(y => y.lang == this.defaultI18n).name,
            };
          });
          this.otas.sort((a, b) => a.name.localeCompare(b.name));
          this.roomMap.forEach(r => {
            r.children = this.otas.map(o => Object.assign({}, {
              id: r.id + '|' + o.id,
              otaId: o.id,
              name: o.name,
              connectedOTA: -1,
              locked: false
            }
            ));
          });
        }
      }).finally(() => (this.initialize()));
    },
    changeIndex() {
      this.editedItem.promotions.sort((a, b) => {
        const indexA = this.listPromotionType_0.indexOf(a);
        const indexB = this.listPromotionType_0.indexOf(b);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) {
          return -1;
        }

        if (indexB !== -1) {
          return 1;
        }
        return 0;
      });
    },
    removePromotion(id) {
      const index = this.editedItem.promotions.findIndex(item => item === id);
      if (index !== -1) {
        this.editedItem.promotions.splice(index, 1);
      }
    },
    addPromotionToList(item) {
      this.editedItem.promotions.push(item.id)
    },
    addPromotion(value) {
      this.typeAddPromotion = value;
      this.dialogPromotion = true
    },  
    async salePackageService() {
      return await salePackageService.getPromotion({
        promotionIds: [],
        languageCode: this.defaultI18n,
        promotionTypes: [0, 1]
      }).then(res => res.data);
    },
    allLeftToRight() {
      this.selectUnmap = [];
      this.roomMap.forEach(r => {
        r.children.forEach(ota => {
          this.selectUnmap.push(ota.id)
        })
      });
      this.leftToRight()
    },
    leftToRight() {
      this.roomMap.slice(this.roomMap.findIndex(r => r.children.length === 0), 1);
      this.roomMap.sort((a, b) => a.name.localeCompare(b.name));
      this.selectUnmap.forEach(item => {
        let roomId = item.split('|')[0];
        let otaId = item.split('|')[1];
        if (!otaId) return
        if(this.roomsMaped.find(r => r.id === roomId)) {
          this.roomsMaped.find(r => r.id === roomId).children.push({
              id: item,
              otaId: otaId,
              name: this.otas.find(e => e.id == otaId) ? this.otas.find(e => e.id == otaId).name : null,
              connectedOTA: -1,
              locked: false
          })
        } else{
          this.roomsMaped.push({
              id: roomId,
              name: this.rooms.find(e => e.id == roomId) ? this.rooms.find(e => e.id == roomId).name : null,
              children: [
                {
                  id: item,
                  otaId: otaId,
                  name: this.otas.find(e => e.id == otaId) ? this.otas.find(e => e.id == otaId).name : null,
                  connectedOTA: -1,
                  locked: false
                }
              ],
          })
        }
      });
      this.roomsMaped.sort((a, b) => a.name.localeCompare(b.name));
      this.selectUnmap = [];
      this.$forceUpdate()
      setTimeout(() => {
        this.roomsMaped.forEach(prod => {
          this.roomMap.forEach(map => {
            if (map.id === prod.id) {
              prod.children.forEach(ota => {
                if (map.children.findIndex(item => item.id === ota.id) != -1) {
                  map.children.splice(map.children.findIndex(item => item.id === ota.id), 1)
                  this.$forceUpdate()
                }
              
              });
            }
          })
        });
        this.roomMap = this.roomMap.filter(room => room.children.length > 0)
      }, 100);
      
    },
    rightToLeft() {
      if (this.selectMap.length === 0) return
      this.selectMap.forEach(item => {
        let roomId = item.split('|')[0];
        let otaId = item.split('|')[1];
        if (!otaId) return
        if(this.roomMap.find(r => r.id === roomId)) {
          this.roomMap.find(r => r.id === roomId).children.push({
              id: item,
              otaId: otaId,
              name: this.otas.find(e => e.id == otaId) ? this.otas.find(e => e.id == otaId).name : null,
              connectedOTA: -2,
              locked: false
          })
        } else{
          this.roomMap.push({
              id: roomId,
              name: this.rooms.find(e => e.id == roomId) ? this.rooms.find(e => e.id == roomId).name : null,
              children: [
                {
                  id: item,
                  otaId: otaId,
                  name: this.otas.find(e => e.id == otaId) ? this.otas.find(e => e.id == otaId).name : null,
                  connectedOTA: -2,
                  locked: false
                }
              ],
          })
        }
      });
      this.roomMap.sort((a, b) => a.name.localeCompare(b.name));
      setTimeout(() => {
        this.roomMap.forEach(prod => {
          this.roomsMaped.forEach(map => {
            if (map.id === prod.id) {
              prod.children.forEach(ota => {
                if (map.children.findIndex(item => item.id === ota.id) != -1) {
                  map.children.splice(map.children.findIndex(item => item.id === ota.id), 1)
                  this.$forceUpdate()
                }
              
              });
            }
          })
        });
        this.roomsMaped = this.roomsMaped.filter(room => room.children.length > 0)
      }, 100);
      this.roomsMaped.sort((a, b) => a.name.localeCompare(b.name));
      this.selectMap = [];
      this.$forceUpdate()
    },
    handleSelectRoom(room,active) {
      console.log(room,active)
    },
    async getAllRooms() {
      let body = {};
      body.keyword = "";
        body.status = `1`;
      body.limit = 9999;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      return await service.getAllRooms(body).then(res => res.data);
    },
    async getOtas() {
      return await syncota.getAllOTA({ keyword: "", status: 1 }).then(res => res.data);
    },
    async getAllTravelAgent() {
      this.listAgent = [];
      let body = {};
      body.keyword = "";
      body.status = null;
      body.limit = 9999999;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      
      return await agentService.getAllTravelAgent(body).then(res => res.data);
    },
    async getAllSegment() {
      this.marketSegments = [];
      return await systemService.getAllSegment().then(res => res.data);
    },
    async getAllRateCategory() {
      let body = {};
      body.keyword = '';
      body.status = null;
      body.limit = 99999999;
      body.offset = 0;
      body.orderBy = '';
      body.asc = false;
      return await categoryService
        .getRateCategoryList(body)
        .then(res => res.data);
    },
    confirmSave() {
      if (this.isConfirmSave) {
        if (!this.editedItem.startDate && this.editedItem.session) {
          this.error.startDate.error = true;
        } else {
          this.error.startDate.error = false;
        }

        if (!this.editedItem.endDate && this.editedItem.session) {
          this.error.endDate.error = true;
        } else {
          this.error.endDate.error = false;
        }
        if (this.error.endDate.error || this.error.startDate.error) {
          store.commit("alert/display", {
            message: this.$t("_VALIDATE.REQUIRED"),
            error: true,
            success: false,
          });
          const el = document.querySelector(".v-messages.error--text:first-of-type");
          el.scrollIntoView();
          return false;
        }
        this.dialogConfirmSave = true;
      } else {
        this.save(false);
      }
    },
    toggleObject() {
      this.$nextTick(() => {
        if (this.likesAllRateParties) {
          this.editedItem.rateParties = [];
        } else {
          // this.editedItem.rateParties = this.select.applyFor.slice();
          this.select.applyFor.forEach((x) => {
            this.editedItem.rateParties.push(x.value);
          });
        }
      });
    },
    toggleCard() {
      this.$nextTick(() => {
        if (this.likesAllCard) {
          this.editedItem.rateCards = [];
        } else {
          // this.editedItem.rateCards = this.select.cardApply.slice();
          this.select.cardApply.forEach((x) => {
            this.editedItem.rateCards.push(x.value);
          });
        }
      });
    },
    toggleMeal() {
      this.$nextTick(() => {
        if (this.likesAllMeal) {
          this.editedItem.lstMealId = [];
        } else {
          this.editedItem.lstMealId = [];
          this.select.meals.forEach((x) => {
            this.editedItem.lstMealId.push(x.value);
          });
          // this.editedItem.lstMealId = this.select.meals.slice();
        }
      });
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    async initialize() {
      this.isLoading = true;
      let id = this.$route.params.id;
      const body = {
        limit: 15,
        offset: 0,
      };
      if (id != 0) {
        Promise.all([
          this.getSalePackageService(id),
          this.getMeal(),
          this.getPaymentPolicy(body),
          this.getCancelPolicy(body),
          this.getApplyForObject(),
          this.getApplyCardType(),
          this.getChannel(),
          this.getMarket()
        ]).then(([
          salePackageService,
          meals,
          paymentPolicy,
          cancelPolicy,
          applyFor,
          cardApply,
          listOfChannels,
          listOfMarkets
        ]) => {
          if (salePackageService) {
            this.editedItem = JSON.parse(JSON.stringify(salePackageService));
            this.editedItem.mappedRoomRates.forEach(prod => {
              if (this.roomMap.find(r => r.id === prod.roomTypeId)) {
                this.roomMap.find(r => r.id === prod.roomTypeId).children.splice(this.roomMap.find(r => r.id === prod.roomTypeId).children.findIndex(item => item.otaId === prod.otaId), 1)
              }
            })
            this.roomMap = this.roomMap.filter(room => room.children.length > 0)
            const arrGroupProd = Object.values(this.editedItem.mappedRoomRates.reduce((acc, obj) => {
              const key = obj.roomTypeId;
              acc[key] = acc[key] || { roomTypeId: key, items: [] };
              acc[key].items.push(obj);
              return acc;
            }, {}));
            this.roomsMaped = [];
            arrGroupProd.forEach(item => {
              this.roomsMaped.push({
                id: item.roomTypeId,
                name: this.rooms.find(e => e.id == item.roomTypeId).name,
                children: item.items
                  .filter(o => this.otas.some(e => e.id == o.otaId))
                  .map(o => ({
                    id: item.roomTypeId + '|' + o.otaId,
                    otaId: o.otaId,
                    name: this.otas.find(e => e.id == o.otaId).name,
                    connectedOTA: o.connectedOTA,
                    locked: o.connectedOTA === 1 ? true : false
                  })),
              });
            });
            if (this.editedItem.travelAgents.includes("00000000-0000-0000-0000-000000000000")) {
              this.travelAgentGeneral = "ALL"
            } else {
              this.travelAgentGeneral = "SPEC"
            }

            if (this.editedItem.marketSegments.includes("00000000-0000-0000-0000-000000000000")) {
              this.marketSegmentGeneral = "ALL"
            } else {
              this.marketSegmentGeneral = "SPEC"
            }

            // Chuyển từ binary sang select
            this.defaultWeekend = this.convertFromBinaryToListSelection(
              salePackageService.bitWeekDays
            );
            var tmp = [];
            this.defaultWeekend.forEach(function (element, index) {
              if (element == 1) {
                if (index == 0) {
                  tmp.push("MON");
                }
                if (index == 1) {
                  tmp.push("TUE");
                }
                if (index == 2) {
                  tmp.push("WED");
                }
                if (index == 3) {
                  tmp.push("THU");
                }
                if (index == 4) {
                  tmp.push("FRI");
                }
                if (index == 5) {
                  tmp.push("SAT");
                }
                if (index == 6) {
                  tmp.push("SUN");
                }
              }
            });
            this.weekend = tmp;

            if (salePackageService.markets == null) {
              this.applyAllMarket = "ALL";
            } else {
              this.applyAllMarket = "NOT_ALL";
            }
            if (salePackageService.channels == null) {
              this.applyAllChannel = "ALL";
            } else {
              this.applyAllChannel = "NOT_ALL";
            }

            if (salePackageService.ratePlanCode) {
              this.isDisableSalePackageCode = true;
            }

            this.clone.editedItem.ratePayments = [...this.editedItem.ratePayments];
            this.clone.editedItem.rateCancellations = [
              ...this.editedItem.rateCancellations,
            ];
          }
          if (meals) {
            this.select.meals = meals.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((y) => y.lang == this.defaultI18n).name,
              };
            });
            this.select.meals = this.select.meals.filter((x) => x.value);
          }

          if (paymentPolicy) {
            this.select.paymentPolicy = paymentPolicy;
          }

          if (cancelPolicy) {
            this.select.cancelPolicy = cancelPolicy;
          }
          if (applyFor) {
            this.select.applyFor = applyFor.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.select.applyFor = this.select.applyFor.filter((x) => x.value);
          }
          if (cardApply) {
            this.select.cardApply = cardApply.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.select.cardApply = this.select.cardApply.filter((x) => x.value);
          }
          if (listOfChannels) {
            this.listOfChannels = listOfChannels.map((x) => {
              return {
                id: x.id,
                value: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.listOfChannels = this.listOfChannels.filter((x) => x.value);
          }

          if (listOfMarkets) {
            this.listOfMarkets = listOfMarkets.map((x) => {
              return {
                id: x.id,
                value: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.listOfMarkets = this.listOfMarkets.filter((x) => x.value);
          }
          if (
            this.editedItem.channels != null &&
            this.listOfChannels.length == this.editedItem.channels.length
          ) {
            this.selectAllChannel = true;
          }

          if (
            this.editedItem.markets != null &&
            this.listOfMarkets.length == this.editedItem.markets.length
          ) {
            this.selectAllMarket = true;
          }
          this.isLoading = false;
        });
      } else {
        this.isAddNew = true;
        this.weekend = ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"];
        this.clone.editedItem.ratePayments = [];
        this.clone.editedItem.rateCancellations = [];
        this.editedItem = {
          status: true,
          ageMaxBaby: 0,
          ageMaxChild: 0,
          bitWeekDays: 179,
          cancellationRulesVi: null,
          channels: null,
          descriptionVi: null,
          endDate: null,
          forPromoCode: null,
          i18ns: [],
          id: null,
          includedTax: false,
          lstMealId: [],
          markets: [],
          nameVi: "",
          needCvv: false,
          parentId: null,
          rateBlackouts: [],
          rateCancellations: [],
          rateCards: [],
          rateLevel: 0,
          rateParties: [],
          ratePaymentTypes: [],
          ratePayments: [],
          ratePlanCode: "",
          session: false,
          startDate: null,
          warrantyType: 0,
          travelAgents: [],
          marketSegments: [],
          promotions: []
        };
        this.codeLangs.forEach(e => {
          this.editedItem.i18ns.push({
          cancellationRules: "cancel",
          description: "",
          lang: e,
          name: "",
          })
        });
        Promise.all([
          this.getMeal(),
          this.getPaymentPolicy(body),
          this.getCancelPolicy(body),
          this.getApplyForObject(),
          this.getApplyCardType(),
          this.getChannel(),
          this.getMarket()
        ]).then(([
          meals,
          paymentPolicy,
          cancelPolicy,
          applyFor,
          cardApply,
          listOfChannels,
          listOfMarkets
        ]) => {
          if (meals) {
            this.select.meals = meals.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((y) => y.lang == this.defaultI18n).name,
              };
            });
            this.select.meals = this.select.meals.filter((x) => x.value);
          }

          if (paymentPolicy) {
            this.select.paymentPolicy = paymentPolicy;
          }

          if (cancelPolicy) {
            this.select.cancelPolicy = cancelPolicy;
          }
          if (applyFor) {
            this.select.applyFor = applyFor.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.select.applyFor = this.select.applyFor.filter((x) => x.value);
          }
          if (cardApply) {
            this.select.cardApply = cardApply.map((x) => {
              return {
                value: x.id,
                text: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.select.cardApply = this.select.cardApply.filter((x) => x.value);
          }
          if (listOfChannels) {
            this.listOfChannels = listOfChannels.map((x) => {
              return {
                id: x.id,
                value: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.listOfChannels = this.listOfChannels.filter((x) => x.value);
          }

          if (listOfMarkets) {
            this.listOfMarkets = listOfMarkets.map((x) => {
              return {
                id: x.id,
                value: x.lookupItemI18n.find((x) => x.lang == this.defaultI18n).name,
              };
            });
            this.listOfMarkets = this.listOfMarkets.filter((x) => x.value);
          }
          this.editedItem.rateParties = this.select.applyFor.map((x) => x.value);
          this.editedItem.rateCards = this.select.cardApply.map((x) => x.value);
          this.isLoading = false;
        });
      }
    },
    async getSalePackageService(id) {
      return await salePackageService.getDetail(id).then(res => res.data);
    },
    async getMeal() {
      return await salePackageService.getMeal().then(res => res.data);
    },
    async getPaymentPolicy(body) {
      return await salePackageService.getPaymentPolicy(body).then(res => res.data);
    },
    async getCancelPolicy(body) {
      return await salePackageService.getCancelPolicy(body).then(res => res.data);
    },
    async getApplyForObject() {
      return await salePackageService.getApplyForObject().then(res => res.data);
    },
    async getApplyCardType() {
      return await salePackageService.getApplyCardType().then(res => res.data);
    },
    async getChannel() {
      return await service.getChannel().then(res => res.data);
    },
    async getMarket() {
      return await service.getMarket().then(res => res.data);
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.i18ns.length; i++) {
          this.editedItem.i18ns[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.i18ns.length; i++) {
        this.editedItem.i18ns[i].description = value;
      }
    },
    updateRoomBenefit(value) {
      for (let i = 0; i < this.editedItem.i18ns.length; i++) {
        this.editedItem.i18ns[i].benefit = value;
      }
    },
    applyAllMarketStatus() {
      if (this.applyAllMarket === "NOT_ALL") {
        this.editedItem.markets = null;
        this.selectAllMarket = false;
      } else {
        this.editedItem.markets = [];
      }
    },
    applyAllChannelStatus() {
      if (this.applyAllChannel === "NOT_ALL") {
        this.editedItem.channels = null;
        this.selectAllChannel = false;
      } else {
        this.editedItem.channels = [];
      }
    },
    clickSelectAllChannel() {
      if (this.selectAllChannel) {
        this.listOfChannels.forEach((e) => {
          this.editedItem.channels.push(e.id);
        });
      } else {
        this.editedItem.channels = [];
      }
    },
    clickSelectAllMarket() {
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach((e) => {
          this.editedItem.markets.push(e.id);
        });
      } else {
        this.editedItem.markets = [];
      }
    },
    validate() { },
    validateAndFocusTab() {
        if (!this.editedItem.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.editedItem.i18ns.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save(replaceOldRestriction) {
      await this.validateAndFocusTab();
      await this.$nextTick();
      let form_validate = this.$refs.form.validate();
      if (!this.editedItem.startDate && this.editedItem.session) {
        this.error.startDate.error = true;
      } else {
        this.error.startDate.error = false;
      }

      if (!this.editedItem.endDate && this.editedItem.session) {
        this.error.endDate.error = true;
      } else {
        this.error.endDate.error = false;
      }

      if (!form_validate || this.error.endDate.error || this.error.startDate.error) {
        store.commit("alert/display", {
          message: this.$t("_VALIDATE.REQUIRED"),
          error: true,
          success: false,
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return false;
      }

      if (form_validate) {
        this.editedItem.ratePaymentsAddIds = this.ratePaymentsAddIds.map((x) => x.id);
        this.editedItem.rateCancellationsAddIds = this.rateCancellationsAddIds.map(
          (x) => x.id
        );

        this.editedItem.rateBlackouts = this.editedItem.rateBlackouts.filter(
          (x) => x.startDate && x.endDate
        );

        this.editedItem.channels =
          this.applyAllChannel == "ALL" ? null : this.editedItem.channels;
        this.editedItem.markets =
          this.applyAllMarket == "ALL" ? null : this.editedItem.markets;

        this.editedItem.replaceOldRestriction = replaceOldRestriction;
        this.editedItem.travelAgents = this.travelAgentGeneral === "ALL" ? ["00000000-0000-0000-0000-000000000000"] : this.editedItem.travelAgents
        this.editedItem.marketSegments = this.marketSegmentGeneral === "ALL" ? ["00000000-0000-0000-0000-000000000000"] : this.editedItem.marketSegments
        this.editedItem.createRoomRates = [];
        this.editedItem.deleteRoomRates = [];
        let createRoomRates = [];
        let deleteRoomRates = [];
        this.roomsMaped.forEach(e => {
          e.children.forEach(ota => {
            if (ota.connectedOTA === -1) {
              createRoomRates.push({
                roomTypeId: e.id,
                otaId: ota.otaId
              });
            }
          });
        });
        
       
        
        this.roomMap.forEach(e => {
          e.children.forEach(ota => {
            if (ota.connectedOTA === -2) {
              deleteRoomRates.push({
                roomTypeId: e.id,
                otaId: ota.otaId
              });
            }
          });
        })
        
        if ( this.editedItem.mappedRoomRates) {
           this.editedItem.mappedRoomRates.forEach(rr => {
            createRoomRates.forEach(e => {
              if (e.otaId === rr.otaId && e.roomTypeId === rr.roomTypeId) {
                e.remove = true;
              }
            });
          }); 
          this.editedItem.createRoomRates = createRoomRates.filter(e => !e.remove);
          this.editedItem.createRoomRates.forEach(e => {
            delete e.remove;
          })
          this.editedItem.mappedRoomRates.forEach(rr => {
            deleteRoomRates.forEach(item => {
              if(item.otaId == rr.otaId && item.roomTypeId == rr.roomTypeId) {
                this.editedItem.deleteRoomRates.push(item)
              }
            })
          });
        } else {
          this.editedItem.createRoomRates = [...createRoomRates];
          this.editedItem.deleteRoomRates = [];
        }
        if (this.editedItem.id) {
          this.disableSaveBtn = true;
          salePackageService.update(this.editedItem).then((res) => {
            _alert(res, this.$t(res.data));
            if (res.responseCode != 0) {
              this.disableSaveBtn = false;
            }
          });
        } else {
          this.disableSaveBtn = true;
          this.editedItem.ratePlanCode = this.editedItem.ratePlanCode.toUpperCase();
          salePackageService.create(this.editedItem).then((res) => {
            if (res.responseCode == 0) {
              _alert(res, this.$t("CREATE_SUCCESS"), false);
            }
            let vm = this;
            setTimeout(function () {
              vm.$router.push({ name: "listOfSalePackages" });
            }, 1000);
            if (res.responseCode != 0) {
              this.disableSaveBtn = false;
              _alert(res, this.$t(res.data));
            }
          });
        }
      }
    },
    back() {
      this.$router.back();
    },
    addnotApplyDates() {
      this.editedItem.rateBlackouts.push({
        startDate: null,
        endDate: null,
      });
    },
    removeRangeApplyDate(index) {
      this.editedItem.rateBlackouts.splice(index, 1);
    },
    addRateCancellationsAddIds(item) {
      var tmp = this.rateCancellationsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.rateCancellationsAddIds.push(item);
      }
    },
    updateRateCancellationsAddIds(item) {
      var tmp = this.editedItem.rateCancellations.map((x) => x.cancellationId);

      if (tmp.includes(item.id)) {
        this.editedItem.rateCancellations.splice(tmp.indexOf(item.id), 1);
      }

      var tmp = this.rateCancellationsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.rateCancellationsAddIds.push(item);
      }
    },
    addRatePaymentsAddIds(item) {
      var tmp = this.ratePaymentsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.ratePaymentsAddIds.push(item);
      }
    },
    updateRatePaymentsAddIds(item) {
      var tmp = this.editedItem.ratePayments.map((x) => x.depositId);

      if (tmp.includes(item.id)) {
        this.editedItem.ratePayments.splice(tmp.indexOf(item.id), 1);
      }
      var tmp = this.ratePaymentsAddIds.map((x) => x.id);
      if (!tmp.includes(item.id)) {
        this.ratePaymentsAddIds.push(item);
      }
    },
    currentDate() {
      let today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //As January is 0.
      var yyyy = today.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      return yyyy + "-" + mm + "-" + dd;
    },
    validateSalePackageCode(salePackageCode, $event) {
      let body = {
        keyword: salePackageCode,
      };
      salePackageService.validateSalePackageCode(body).then(async (res) => {
        if (res.responseCode == 0) {
          if (res.data) {
            this.isDuplicateSalePackageCode = true;
          } else {
            this.isDuplicateSalePackageCode = false;
          }
        }
      });
    },
    isCancelSelected(id) {
      if (this.clone.editedItem.rateCancellations.length >= 0) {
        let temp = this.clone.editedItem.rateCancellations.map((x) => x.cancellationId);
        if (temp.includes(id)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isPaymentSelected(id) {
      if (this.clone.editedItem.ratePayments.length >= 0) {
        let temp = JSON.parse(JSON.stringify(this.clone.editedItem.ratePayments)).map((x) => x.depositId);
        if (temp.includes(id)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    removeOldCancellation(index) {
      this.editedItem.rateCancellations.splice(index, 1);
    },
    removeOldratePayments(index) {
      this.editedItem.ratePayments.splice(index, 1);
    },
    removeNewratePayments(index) {
      this.ratePaymentsAddIds.splice(index, 1);
    },
    removeNewCancellation(index) {
      this.rateCancellationsAddIds.splice(index, 1);
    },
    _formatCurrency: _formatCurrency,
  },
};
</script>
